module.exports = __webpack_public_path__ + "static/black-edge-c87504f1fe16f2597369724f6ff9392a.jpg";